import ErrorPage from './ErrorPage.tsx';

export default ErrorPage;
